import { Text } from '@grammarly/design-system'
import type { ComponentProps } from 'react'

import styles from './AnimatedCounter.module.scss'
import { useCounterAnimation } from './useCounterAnimation'

type TextProps = ComponentProps<typeof Text>

interface Props extends Omit<TextProps, 'value' | 'as' | 'children'> {
  value: number
  /** Custom animation duration in milliseconds. Defaults to CSS value or 200ms */
  animationDuration?: number
}

export function AnimatedCounter(props: Props) {
  const { value, animationDuration, ...textProps } = props

  const { currentCount, oldCount, isAnimating, animationDirection, containerRef, onAnimationEnd } =
    useCounterAnimation(value)

  return (
    <div ref={containerRef} className={styles.assistantUIAnimatedCounterContainer} role="status">
      {isAnimating && oldCount !== undefined && (
        <Text
          as="p"
          className={`${styles.assistantUIAnimatedCounterText} ${
            animationDirection === 'up'
              ? styles.assistantUIAnimatedCounterFadeOutDown
              : styles.assistantUIAnimatedCounterFadeOutUp
          }`}
          aria-hidden="true"
          {...textProps}
        >
          {oldCount}
        </Text>
      )}

      <Text
        as="p"
        className={`${styles.assistantUIAnimatedCounterText} ${
          isAnimating
            ? animationDirection === 'up'
              ? styles.assistantUIAnimatedCounterFadeInFromTop
              : styles.assistantUIAnimatedCounterFadeInFromBottom
            : styles.assistantUIAnimatedCounterVisible
        }`}
        onAnimationEnd={onAnimationEnd}
        {...textProps}
      >
        {currentCount}
      </Text>
    </div>
  )
}
